import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            {contactData.desc}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-500 rounded-xl mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">邮箱</div>
              <div className="text-sm font-semibold text-foreground-900 break-all">{contactData.email}</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-500 rounded-xl mx-auto mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信</div>
              <div className="text-sm font-semibold text-foreground-900">{contactData.wechat}</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 text-secondary-500 rounded-xl mx-auto mb-3">
                <i className="ri-qq-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">QQ</div>
              <div className="text-sm font-semibold text-foreground-900">{contactData.qq}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}